import apiFetch from '../apiFetch'

export default function (financingId, token) {
  return apiFetch({ endPoint: 'financeCompany/' + financingId, method: 'DELETE', body: null, token: token })
}
